/**
 * Settings page — placeholder for P1+. Will contain profile settings,
 * AI usage / quota display, and API key management.
 */
export default function SettingsPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto flex h-16 items-center px-4">
          <h1 className="text-xl font-semibold">Settings</h1>
        </div>
      </header>
      <main className="container mx-auto px-4 py-12">
        <p className="text-muted-foreground">Settings coming soon.</p>
      </main>
    </div>
  );
}
